module.controller(
    'contactDetailCtrl',
    [ '$scope', '$rootScope', '$state', 'clientService', 'alertService', 
        function($scope, $rootScope, $state, clientService, alertService) {
            
    		$scope.operationType = $state.current.data.type;
            $scope.idClient = $state.params.idClient;
            $scope.idContact = $state.params.idContact;
            $scope.contact = {};
            $scope.loading = false;

            /**
             *
             * @param idUser
             */
            $scope.load = function(idClient, idContact) {
                $scope.loading = true;

                clientService.getClientContact(idClient, idContact).then(function(response) {
                    $scope.loading = false;

                    var responseData = response.getData();
                    $scope.contact = responseData;
                }, function(response) {
                    $scope.loading = false;
                });
            };

            /**
             *
             */
            $scope.sendAction = function() {
                if ($scope.operationType == 'create') {
                    $scope.create();
                } else {
                    $scope.update();
                }
            };

            /**
             *
             */
            $scope.create = function() {
                alertService.showSwtQuestion('Crear Contacto', function() {
                    $scope.loading = true;

                    var createModel = {
                    	name: $scope.contact.name,
                    	email: $scope.contact.email,
                    	telephone: $scope.contact.telephone,
                    	cellphone: $scope.contact.cellphone,
                    	position: $scope.contact.position,
                    	division: $scope.contact.division
                    };

                    clientService.createClientContact($scope.idClient, createModel).then(function(response) {
                        $scope.loading = false;
                        $state.go('home.clientContacts', {idClient : $scope.idClient});
                        
                        alertService.showSuccess('Contacto creado satisfactoriamente');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };

            /**
             *
             */
            $scope.update = function() {
                alertService.showSwtQuestion('Actualizar Contacto', function() {
                    $scope.loading = true;

                    var updateModel = {
                    		name: $scope.contact.name,
                        	email: $scope.contact.email,
                        	telephone: $scope.contact.telephone,
                        	cellphone: $scope.contact.cellphone,
                        	position: $scope.contact.position,
                        	division: $scope.contact.division
                    };

                    clientService.updateClientContact($scope.idClient, $scope.idContact, updateModel).then(function(response) {
                        $scope.loading = false;
                        alertService.showSuccess('Contacto actualizado satisfactoriamente');
                        $state.go('home.clientContacts', {idClient : $scope.idClient});
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };


            if ($scope.operationType == 'update') {
                $scope.load($scope.idClient, $scope.idContact);
            }

        } ]);


